import type { ReduxState as State } from '../index';

export const getBreeds = (state: State) => state.dogBreeds || [];
